import React, { useState, useEffect } from 'react';
import { Popup, PopupHeader, Toast } from 'react-weui';
import { history } from 'umi';
// import wx from 'wx';
import styles from './styles.scss';
import icon_point from '@/assets/live/icon_point.png';
import icon_share from '@/assets/live/icon_share.png';

// import user_img from '@/assets/user.svg';
import AppLaunch from '@/components/AppLaunch';
import { updateWxShareInfo } from '@/utils/utils';

import { getUserInfo, checkPointStatus, getCoursePrivilege } from '@/services/myself';
import { createVzanPoints } from '@/services/vzan';
// import { Toast } from 'antd-mobile';

const SHARE_PIC_KEY = "share_pic";
const SHARE_LIVE_KEY = "share_live";

const pointsTask = [
  {
    pointsTitle: '签到打卡',
    pointsNumber: 2,
    pointsUrl: null,
    button: (logSet) => (
        <div className={styles.navAppContainer}>
          <AppLaunch appPath={"pages/sign/index"}>
            <div className={styles.button + " " + (logSet.has(1) ? styles.buttonGray : "")}>挣积分</div>
          </AppLaunch>
        </div>
      )

  }, {
    pointsTitle: '答题',
    pointsNumber: 1,
    pointsUrl: null,
    button: (logSet) => (
      <div className={styles.navAppContainer}>
        <AppLaunch appPath={"pages/answer/start/start"}>
          <div className={styles.button + " " + (logSet.has(8) ? styles.buttonGray : "")}>挣积分</div>
        </AppLaunch>
      </div>
      ),
  }, {
    pointsTitle: '幸福课堂',
    pointsNumber: 2,
    logType: 9,
    pointsUrl: '/nav/home',
  }, {
    pointsTitle: '观看电视栏目',
    pointsNumber: 2,
    logType: 9,
    pointsUrl: '/nav/program',
  }, {
    pointsTitle: '观看幸福直播',
    pointsNumber: 5,
    logType: 17,
    pointsUrl: '/live/home',
  }, {
    pointsTitle: '分享直播间',
    pointsNumber: 5,
    logType: 18,
    pointsUrl: SHARE_LIVE_KEY,
  }, {
    pointsTitle: '邀请新伙伴',
    pointsNumber: 15,
    logType: 16,
    pointsUrl: SHARE_PIC_KEY,
  }, {
    pointsTitle: '发表评论',
    pointsNumber: 2,
    logType: 11,
    pointsUrl: '/nav/home',
  }
];

const shareLiveInfo = ({id, nickname, successConfig, successCallback}) => {

  const title = `${nickname}邀请您收看幸福直播`;
  const desc = "幸福全家分享美好时光";
  const link = `${window.location.origin}/live/home`;
  const imgUrl = `${window.location.origin}/logo.png`;

  updateWxShareInfo({
    title,
    desc,
    link,
    imgUrl,
    successConfig,
    successCallback
  });

}

const updateShareInfo = ({id, nickname, successConfig}) => {

  const title = `${nickname}邀请您加入幸福全家`;
  const desc = "幸福全家分享美好时光";
  const link = `${window.location.origin}/invite/${id}`;
  const imgUrl = `${window.location.origin}/logo.png`;


  updateWxShareInfo({
    title,
    desc,
    link,
    imgUrl,
    successConfig
  });

}

const ShopLaunch = ({children, appPath, name}) => {
  return (
    <div className={styles.lineTitle}>
      {children}
      <wx-open-launch-weapp
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          width: '100%',
          height: '100%',
        }}
        id={'launch-btn'}
        username={name ? name : username}
        path={appPath}
      >
        <script type="text/wxtag-template">
          <div style={{ position: 'absolute', left: 0, top: 0, width: '100%', height: '100%' }}/>
        </script>
      </wx-open-launch-weapp>
    </div>
  )
}

export default () => {

  const [user, setUser] = useState({});
  const [logSet, setLogSet] = useState(new Set());
  const [showInvite, setShowInvite] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [logLoading, setLogLoading] = useState(false);

  useEffect(() => {
    setShowLoading(true);
    getUserInfo().then(res => {
      if (res && res.code === 200) {
        setUser(res.data);
        updateShareInfo(res.data);
      }else {
        // Toast.fail('获取失败，请重试');
      }
    }).finally(() => setShowLoading(false));
    getPowerLogStatus({});
  }, []);

  const getPowerLogStatus = (params) => {
    setLogLoading(true);
    checkPointStatus(params)
      .then(res => {
        if (res && res.code === 200) {
          setLogSet(new Set(res.data));
        }
      })
      .finally(() => setLogLoading(false));
  }


  return (
    <div className={styles.pageContainer} >
      <div className={styles.headerContainer} >

        <div className={styles.imageContainer}>
          <img src={user.avatarurl} />
        </div>
        <div className={styles.headerTitleContainer}>
          <div>{user.nickname}</div>
          <div>幸福全家</div>
        </div>
        <div className={styles.headerTitleContainer}>
          <div>{user.fruit}</div>
          <div>我的果实</div>
        </div>
        <div className={styles.headerTitleContainer}>
          <div>{user.power}</div>
          <div>当前积分</div>
        </div>

      </div>

      <div className={styles.lineContainer}>
        <ShopLaunch name={"gh_1915308a9815"} appPath={"pages/index/index"}>
          <div>积分兑换</div>
        </ShopLaunch>
      </div>

      <div className={styles.listTitle}>积分任务&nbsp;>&nbsp;>&nbsp;></div>
      <div className={styles.pointsListContainer}>
        {
          pointsTask.map((item, index) => (
            <div className={styles.pointsTaskItem} key={index}>
              <div className={styles.pointsTaskTitle}>{item.pointsTitle}</div>
              <div className={styles.pointsContent}>
                <div className={styles.pointsNumber}>
                  <img src={icon_point} />&nbsp;&nbsp;
                  {item.pointsNumber}&nbsp;&nbsp;积分
                </div>
                {
                  item.pointsUrl ? (
                    <div className={styles.button + " " + (logSet.has(item.logType) ? styles.buttonGray : "")} onClick={() => {
                      if (item) {
                        // console.log(item.pointsUrl);
                        switch (item.pointsUrl) {
                          case SHARE_PIC_KEY:
                            setShowLoading(true);
                            updateShareInfo({
                              ...user,
                              successConfig: () => {
                                setShowLoading(false);
                                setShowInvite(true);
                              }
                            });
                            break;
                          case SHARE_LIVE_KEY:
                            setShowLoading(true);
                            shareLiveInfo({
                              ...user,
                              successConfig: () => {
                                setShowLoading(false);
                                setShowInvite(true);
                                createVzanPoints('share')
                                  .then(res => console.log(res))
                                  .finally(() => getPowerLogStatus({}));
                              },
                              successCallback: () => {
                              }
                            });
                            break;
                          default:
                            history.push(item.pointsUrl);
                        }
                      }
                    }}>挣积分</div>
                  ) : (typeof item.button === 'function' && item.button(logSet))
                }

              </div>
            </div>
          ))
        }
      </div>
      <Toast icon="loading" show={showLoading || logLoading}>加载中...</Toast>
      <Popup show={showInvite} style={{'opacity': '0.9'}} onRequestClose={() => setShowInvite(false)}>
        <div className={styles.popupContainer} onClick={() => setShowInvite(false)}>
          <img src={icon_share} />

          {/*<div className={styles.title}>点击这里分享给其他用户。</div>*/}

        </div>
      </Popup>
    </div>
  )
}




